import { PulseError } from '@prenuvo/pulse';

import { authInterceptorHandler } from './auth-interceptor.util';
import { normalizeApiErrorResponseBody } from './normalize-api-error-response.util';

export function handleApiError(error: PulseError) {
  const data = error.response?.data;

  if (error.response && data !== undefined) {
    error.response.data = normalizeApiErrorResponseBody(data) ?? data;
  }

  return authInterceptorHandler(error);
}
